module.exports = __webpack_public_path__ + "static/media/image_40.7b6b5b52.png";